
export const profileimg = require('./profileimg.png');
export const adminIcon = require('./admin.png');
export const booking = require('./booking.png');
export const contactus = require('./contactus.png');
export const downarrow = require('./downarrow.png');
export const dashboard = require('./dashboard.png');
export const FAQ = require('./FAQ.png');
export const logoutIcon = require('./logout.png');
export const notify = require('./notify.png');
export const roles = require('./roles.png');
export const support = require('./support.png');
export const transection = require('./transection.png');
export const transport = require('./transport.png');
export const users = require('./users.png');
export const vehicle = require('./vehicle.png');
export const headermsg = require('./headermsg.png');
export const headericon = require('./admin-icon.png');

export const dash1 = require('./dash1.png');
export const dash2 = require('./dash2.png');
export const dash3 = require('./dash3.png');
export const dash4 = require('./dash4.png');

export const tableEye = require('./tableEye.png');
export const deletee = require('./Vector.png');
export const leftArrow = require('./leftArrow.png');
export const defaultImg = require('./defaultImg.png');
export const fileupload = require('./fileupload.png');
export const previewfile = require('./previewfile.png');
export const userarrow = require('./userarrow.png');
export const calendar = require('./calendarr.png');
export const time = require('./time.png');
export const dropdownarrow = require('./dropdownarrow.png');
export const editBook = require('./editBook.png');